import _ from "lodash";
import moment from "moment";
import { Company } from "../../../gateway/Company/Company";

export class AccountingAnalyticsCalculate {
    constructor({ Series, Points }) {
        this.Series = Series;
        this.Points = Points;

        this.Company = new Company();
    }

    result({ serieIds, timesBetween, filterQuery, dates }) {
        const series = this.getSeries({ _id: { $in: serieIds } });

        const points = this.exec({
            series: series,
            timesBetween,
            filterQuery,
            dates
        });

        return points;
    }

    exec({ series, timesBetween, filterQuery, dates }) {
        const points = [];

        const _between = (x, min, max) => {
            return (x - min) * (x - max) <= 0;
        };

        series.forEach((serie) => {
            points.push(
                ...this.calcRun({
                    serie,
                    dates,
                    timesBetween,
                    filterQuery
                })
            );
        });

        const _points = _.sortBy(points, "t");

        const filterPoints = _points.filter((point) => {
            if (_between(+point.t, +timesBetween.start, +timesBetween.end)) {
                return point;
            }
        });

        return filterPoints;
    }

    getPoints(selector) {
        const points = this.Points.findCollection(selector, {}, "array");
        return points.map((point) => {
            return {
                ...point,
                t: new Date(point.t)
            };
        });
    }

    getSeries(filterQuery) {
        return this.Series.findCollection(filterQuery, {}, "array");
    }

    getPropSeries(filterQuery, prop) {
        const series = this.getSeries(filterQuery);

        return series.map((s) => s[prop]);
    }

    calcRun({ serie, dates, timesBetween, filterQuery }) {
        const resultPoints = [];
        dates.forEach((date) => {
            const resultCalc = this._operation({
                serie,
                date,
                timesBetween,
                filterQuery
            });

            resultPoints.push({
                s: serie._id,
                v: resultCalc,
                t: new Date(date)
            });
        });

        return resultPoints;
    }

    _operation({ serie, date, timesBetween, filterQuery }) {
        const _getPointsFeesBySelect = (
            selector,
            serieId = "FEES_BY_MONTH"
        ) => {
            const companiesSeriesIds = this.getPropSeries(selector, "_id");

            let select = {
                c: { $in: companiesSeriesIds },
                s: serieId
            };

            const points = this.getPoints(select);

            const pointReturn = [];

            // _.forEach(_.groupBy(points, "c"), (point) => {
            //     const sortedPoints = _.sortBy(point, "t");
            //     // const pointUse = _.findLast(sortedPoints, (p) => {
            //     //     return +new Date(p.t) <= +new Date(date);
            //     // });

            //     if (pointUse) pointReturn.push(sortedPoints);
            // });

            return points;
        };

        const _somaraze = (points, lessThan = false) => {
            let pointsFilterDate = [];

            if (lessThan) {
                if (points.length) {
                    pointsFilterDate = points.filter(
                        (p) => +new Date(p.t) <= +new Date(date)
                    );
                }
            } else {
                if (points.length) {
                    pointsFilterDate = points.filter(
                        (p) => +new Date(p.t) == +new Date(date)
                    );
                }
            }

            const total = pointsFilterDate.reduce((prev, acc) => {
                return Number(prev) + Number(acc.v || 0);
            }, 0);

            return total;
        };

        const _counter = () => {
            return this.getTotalCompanies({
                date,
                filterQuery
            });
        };

        const _counterByGroup = (operation) => {
            return this.getTotalCompanies({
                date,
                filterQuery: {
                    ...filterQuery,
                    [operation.group]: operation.value
                }
            });
        };

        const _result = (totalFees, totalCompany) => {
            let result = totalFees / totalCompany;

            return isFinite(result) ? result : 0;
        };

        const _getScoreColor = (label) => {
            const labels = {
                ALTO: "cyan.dark",
                MEDIO: "yellow.dark",
                BAIXO: "purple.dark"
            };

            return labels[label] || "basic.lightness";
        };

        const sumFees = (companies) => {
            if (!_.get(companies, "length")) return 0;

            return companies.reduce(
                (prev, acc) => Number(prev) + Number(acc.lastFee || 0),
                0
            );
        };

        const _getBillingRisk = (companies = [], date) => {
            const month = date.getUTCMonth() + 1;
            const year = date.getUTCFullYear();

            const regularMonth = String(month).padStart(2, "0");

            const dateToCompare = Number(`${year}${regularMonth}`);

            return companies.reduce((prev, acc) => {
                const previousFees = acc.fees.filter((f) => {
                    const fMonth = new Date(f.t).getUTCMonth() + 1;
                    const fYear = new Date(f.t).getUTCFullYear();

                    const regularFMonth = String(fMonth).padStart(2, "0");

                    const fDateCompare = Number(`${fYear}${regularFMonth}`);

                    return fDateCompare <= dateToCompare;
                });

                if (!previousFees.length) return Number(prev) + 0;

                const sortedFees = _.sortBy(previousFees, "t");

                const fee = _.last(sortedFees);

                return Number(prev) + Number(_.get(fee, "v", 0));
            }, 0);
        };

        const operation = _.get(serie, "operation");

        if (operation.func == "sumFees") {
            const points = _getPointsFeesBySelect({
                type: "raw",
                ...filterQuery
            });

            return points.reduce((prev, acc) => {
                return Number(prev) + Number(acc.v || 0);
            }, 0);
        } else if (operation.func == "sumFeesLast") {
            const points = _getPointsFeesBySelect(
                {
                    type: "raw",
                    ...filterQuery
                },
                "LAST_FEES_BY_MONTH"
            );

            return points.reduce((prev, acc) => {
                return Number(prev) + Number(acc.v || 0);
            }, 0);
        } else if (operation.func == "scoreAccountingByType") {
            const points = this.getPoints({ s: "SCORE_ACCOUNTING" });

            const month = date.getUTCMonth() + 1;
            const year = date.getUTCFullYear();

            const dateToCompare = `${year}-${month}`;
            const point = points.find((p) => {
                const pDateCompare = `${p.t.getUTCFullYear()}-${
                    p.t.getUTCMonth() + 1
                }`;

                return pDateCompare === dateToCompare;
            });

            return _.get(point, `m.${serie.path}`, 0);
        } else if (operation.func == "customerEngagement") {
            const points = this.getPoints({ s: serie._id });

            const month = date.getUTCMonth() + 1;
            const year = date.getUTCFullYear();

            const dateToCompare = `${year}-${month}`;
            const point = points.find((p) => {
                const pDateCompare = `${p.t.getUTCFullYear()}-${
                    p.t.getUTCMonth() + 1
                }`;

                return pDateCompare === dateToCompare;
            });

            return _.get(point, `m.v`, 0);
        } else if (operation.func == "billingRiskLow") {
            const companies = this.Company.findCollection(
                {
                    status: "ATIVO",
                    $or: [{ public: { $exists: false } }, { public: false }],
                    "events.fromAccounting": { $exists: false }
                },
                {},
                "array"
            );

            const companiesGrouped = _.groupBy(companies, "score");

            const sumFees = _getBillingRisk(companiesGrouped["BAIXO"], date);

            return sumFees;
        } else if (operation.func == "billingRiskMedium") {
            const companies = this.Company.findCollection(
                {
                    status: "ATIVO",
                    $or: [{ public: { $exists: false } }, { public: false }],
                    "events.fromAccounting": { $exists: false }
                },
                {},
                "array"
            );

            const companiesGrouped = _.groupBy(companies, "score");

            const sumFees = _getBillingRisk(companiesGrouped["MEDIO"], date);

            return sumFees;
        } else if (operation.func == "billingRiskHigh") {
            const companies = this.Company.findCollection(
                {
                    status: "ATIVO",
                    $or: [{ public: { $exists: false } }, { public: false }],
                    "events.fromAccounting": { $exists: false }
                },
                {},
                "array"
            );

            const companiesGrouped = _.groupBy(companies, "score");

            const sumFees = _getBillingRisk(companiesGrouped["ALTO"], date);

            return sumFees;
        } else if (operation.func == "scoreAccounting") {
            const points = this.getPoints({ s: "SCORE_ACCOUNTING" });

            const month = date.getUTCMonth() + 1;
            const year = date.getUTCFullYear();

            const dateToCompare = `${year}-${month}`;
            const point = points.find((p) => {
                const pDateCompare = `${p.t.getUTCFullYear()}-${
                    p.t.getUTCMonth() + 1
                }`;

                return pDateCompare === dateToCompare;
            });

            if (_.get(point, "m"))
                point.m.color = _getScoreColor(point.m.label);

            return _.get(point, `m`, {
                high: 0,
                medium: 0,
                low: 0,
                total: 0,
                label: "",
                color: _getScoreColor("")
            });
        } else if (operation.func == "scoreAccountings") {
            const points = this.getPoints({ s: "SCORE_ACCOUNTINGS" });

            const month = date.getUTCMonth() + 1;
            const year = date.getUTCFullYear();

            const dateToCompare = `${year}-${month}`;
            const point = points.find((p) => {
                const pDateCompare = `${p.t.getUTCFullYear()}-${
                    p.t.getUTCMonth() + 1
                }`;

                return pDateCompare === dateToCompare;
            });

            return _.get(point, `m.${serie.path}`);
        } else if (operation.func == "impactAccountings") {
            const points = this.getPoints({ s: "IMPACT_ACCOUNTINGS" });

            const month = date.getUTCMonth() + 1;
            const year = date.getUTCFullYear();

            const dateToCompare = `${year}-${month}`;
            const point = points.find((p) => {
                const pDateCompare = `${p.t.getUTCFullYear()}-${
                    p.t.getUTCMonth() + 1
                }`;

                return pDateCompare === dateToCompare;
            });

            return _.get(point, `m.${serie.path}`);
        } else if (operation.func == "billingAccountings") {
            const points = this.getPoints({ s: "BILLING_ACCOUNTINGS" });

            const month = date.getUTCMonth() + 1;
            const year = date.getUTCFullYear();

            const dateToCompare = `${year}-${month}`;
            const point = points.find((p) => {
                const pDateCompare = `${p.t.getUTCFullYear()}-${
                    p.t.getUTCMonth() + 1
                }`;

                return pDateCompare === dateToCompare;
            });

            return _.get(point, `m.${serie.path}`);
        } else if (operation.func == "sumFeesByMonth") {
            const points = _getPointsFeesBySelect({
                type: "raw",
                ...filterQuery
            });

            let pointsFilterDate = [];

            if (points.length) {
                pointsFilterDate = points.filter(
                    (p) => +new Date(p.t) <= +new Date(date)
                );
            }

            const pointResult = [];
            _.forEach(_.groupBy(pointsFilterDate, "c"), (points, key) => {
                let newPoints = [];

                if (points.length > 1) {
                    newPoints = points.map((v) => {
                        return {
                            tInt: +v.t,
                            ...v
                        };
                    });

                    const resultSort = _.last(_.sortBy(newPoints, ["tInt"]));

                    pointResult.push(resultSort);
                } else {
                    if (points.length) pointResult.push(points[0]);
                }
            });

            const total = pointResult.reduce((prev, acc) => {
                return Number(prev) + Number(acc.v || 0);
            }, 0);

            return total;
        } else if (operation.func == "sumFeesBy") {
            const newPoints = _getPointsFeesBySelect({
                type: "raw",
                ...filterQuery,
                [operation.group]: operation.value
            });

            let pointsFilterDate = [];

            if (newPoints.length) {
                pointsFilterDate = newPoints.filter(
                    (p) => +new Date(p.t) <= +new Date(date)
                );
            }

            const pointResult = [];
            _.forEach(_.groupBy(pointsFilterDate, "c"), (points, key) => {
                let newPoints = [];

                if (points.length > 1) {
                    newPoints = points.map((v) => {
                        return {
                            tInt: +v.t,
                            ...v
                        };
                    });

                    const resultSort = _.last(_.sortBy(newPoints, ["tInt"]));

                    pointResult.push(resultSort);
                } else {
                    if (points.length) pointResult.push(points[0]);
                }
            });

            const total = pointResult.reduce((prev, acc) => {
                return Number(prev) + Number(acc.v || 0);
            }, 0);

            return total;
        } else if (operation.func == "count") {
            return _counter();
        } else if (operation.func == "countBy") {
            return _counterByGroup(operation);
        } else if (operation.func == "calcAverageticket") {
            const points = _getPointsFeesBySelect(
                {
                    type: "raw",
                    ...filterQuery
                },
                "LAST_FEES_BY_MONTH"
            );

            const result = points.reduce((prev, acc) => {
                return Number(prev) + Number(acc.v || 0);
            }, 0);

            return _result(result, _counter());
        } else if (operation.func == "countPercentage") {
            return _result(_counterByGroup(operation), _counter()) * 100;
        } else if (operation.func == "countByDeliveryShared") {
            const companyIds = this.getPropSeries(
                {
                    type: "raw",

                    ...filterQuery,
                    [operation.group]: operation.value
                },
                "_id"
            );

            const points = this.getPoints({
                c: { $in: companyIds },
                s: serie.refereceId
            });

            const total = _somaraze(points);

            return total;
        } else if (operation.func == "countBySourceDeliveryShared") {
            const companyIds = this.getPropSeries(
                {
                    type: "raw",
                    ...filterQuery
                },
                "_id"
            );

            const points = this.getPoints({
                c: { $in: companyIds },
                s: serie.refereceId,
                so: operation.value
            });

            const total = _somaraze(points);

            return total;
        } else if (operation.func == "countPercentageBySourceDeliveryShared") {
            const companyIds = this.getPropSeries(
                {
                    type: "raw",
                    ...filterQuery
                },
                "_id"
            );

            const pointsBySource = this.getPoints({
                c: { $in: companyIds },
                s: serie.refereceId,
                so: operation.value
            });

            const totalBySource = _somaraze(pointsBySource);

            const pointsAllSources = this.getPoints({
                c: { $in: companyIds },
                s: serie.refereceId
            });

            const total = _somaraze(pointsAllSources);

            return _result(totalBySource, total) * 100;
        } else if (operation.func == "countDaysBySourceDeliveryShared") {
            const companyIds = this.getPropSeries(
                {
                    type: "raw",
                    ...filterQuery
                },
                "_id"
            );

            const points = this.getPoints({
                c: { $in: companyIds },
                s: serie.refereceId,
                so: operation.value,
                t: {
                    $gte: timesBetween.start,
                    $lte: timesBetween.end
                }
            });

            const total = points.reduce((prev, acc) => {
                return Number(prev) + Number(acc.v || 0);
            }, 0);

            return total;
        } else if (operation.func == "sumKPI") {
            const companyIds = this.getPropSeries(
                {
                    type: "raw",
                    ...filterQuery
                },
                "_id"
            );

            const points = this.getPoints({
                c: { $in: companyIds },
                s: serie.refereceId,
                t: {
                    $gte: timesBetween.start,
                    $lte: timesBetween.end
                }
            });

            const total = _somaraze(points);

            return total;
        } else if (operation.func == "avaregeKPI") {
            const companyIds = this.getPropSeries(
                {
                    type: "raw",
                    ...filterQuery
                },
                "_id"
            );

            const points = this.getPoints({
                c: { $in: companyIds },
                s: serie.refereceId,
                t: {
                    $gte: timesBetween.start,
                    $lte: timesBetween.end
                }
            });

            const total = _somaraze(points);

            return _result(total, _counter());
        } else {
            return 0;
        }
    }

    getTotalCompanies({ date, filterQuery }) {
        const total = this.Series.countCollection({
            type: "raw",
            $or: [
                {
                    time: {
                        // $gte: new Date(moment(date).format()),
                        $lt: new Date(moment(date).endOf("month").format())
                    }
                },
                { time: false }
            ],
            ...filterQuery
        });

        return total;
    }
}
